// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchPopup-cls1_7O3","cls2":"SearchPopup-cls2_NZY SearchPopup-cls1_7O3","show":"SearchPopup-show_tEe"};